export default __webpack_public_path__ + "static/media/O-123.6f5effda.png";